// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._5\\+M5V{display:flex;padding:16px;border:1px solid #e2e2e2;background-color:#fff;border-radius:8px}@media screen and (min-width:768px){._5\\+M5V{background-size:0}}@media screen and (min-width:1552px){._5\\+M5V{background-position:calc(100% - 88px) 100%;background-size:auto 120px}}@media screen and (min-width:768px){.QWRMI{display:block;width:120px;height:120px;flex-shrink:0;margin-right:24px;background-color:#e2e2e2;border-radius:4px;-o-object-fit:cover;object-fit:cover}}.y1-JK{width:100%;flex:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"podcastCard": "_5+M5V",
	"image": "QWRMI",
	"body": "y1-JK"
};
module.exports = ___CSS_LOADER_EXPORT___;
